export default "__VITE_ASSET__BTwa7G6U__"